import { motion } from "framer-motion";
import { landingMotionInView } from "@/utils/landingMotion";
import { ReviewSlider } from "../landing/ReviewSlider";
import Hero3dCrousel from "./Hero3dCrousel";

export default function HeroSection() {
    return (
        <div
            className={` relative w-full -mt-[85px] pt-40 md:pt-36  text-white   `}
        >
            <video
                className="absolute -mt-5 top-0 z-10 inset-0 h-full w-full object-cover hidden md:block"
                autoPlay
                loop
                muted
                playsInline
            >
                <source src="/assets/HeroBackground.mp4" type="video/mp4" />
            </video>

            <video
                className="absolute top-0 z-30 h-[900px] w-full object-cover block md:hidden"
                autoPlay
                loop
                muted
                playsInline
            >
                <source src="/assets/phonevideo.mp4" type="video/mp4" />
            </video>

            {/* bottom black mask */}
            <div className="absolute bottom-0 left-0 w-full h-[200px] 2xl:h-[10%] bg-gradient-to-t from-black to-transparent z-20"></div>

            <div className="max-w-[2320px] mx-auto relative">
                <motion.div
                    className="hidden md:block md:absolute z-20 bottom-10  left-20 "

                >
                    <ReviewSlider variant="programs" />
                    {/* subtitle The lading prop firm */}
                    <motion.div
                        className="w-fit h-auto p-[1.5px] rounded-[20px] bg-gradient-to-r from-[#1CCDE6] to-[#DBD633] flex justify-center items-center"

                    >
                        <div className="w-fit px-3 bg-black text-dark rounded-[20px]  flex items-center justify-center">
                            <span
                                className="bg-clip-text text-[12px] text-transparent font-nexa font-bold"
                                style={{
                                    backgroundImage:
                                        "linear-gradient(to left, #D7D536, #20CDE2)",
                                    display: "inline-block",
                                }}
                            >
                                {("Reviews provided by")}
                            </span>
                        </div>
                    </motion.div>
                </motion.div>

                <div className=" pb-16 bg-no-repeat bg-contain lg:bg-cover bg-center max-w-[1240px] mx-auto relative z-40">
                    <div className="relative z-10 mx-auto flex flex-col justify-center items-center max-w-[750px]">
                        {/* subtitle The lading prop firm */}
                        <motion.div
                            className="w-fit h-auto p-[1.5px] rounded-[20px] bg-gradient-to-r from-[#1CCDE6] to-[#DBD633] flex justify-center items-center"
                            {...landingMotionInView}
                        >
                            <div className="w-fit px-3 bg-black text-white rounded-[20px] p-1 flex items-center justify-center">
                                <span
                                    className="bg-clip-text text-[12px] sm:text-[13px] xl:text-base text-transparent font-nexa font-bold uppercase"
                                    style={{
                                        backgroundImage:
                                            "linear-gradient(to left, #D7D536, #20CDE2)",
                                        display: "inline-block",
                                    }}
                                >
                                    {("Trusted by Thousands")}
                                </span>
                            </div>
                        </motion.div>
                        <motion.h1
                            className="text-[32px] px-10 md:px-0 text-center md:text-[56px] leading-tight font-bold pt-2 pb-5"
                            {...landingMotionInView}
                        >
                            Trade with Up to $1,000,000 in Capital<span className="italic text-gradient font-light px-2 ">-Instantly</span>
                        </motion.h1>
                        <motion.p
                            className="text-base px-4 xl:px-0 text-white font-nexa text-center md:text-xl max-w-[740px] mx-auto font-normal pt-0 pb-10"
                            {...landingMotionInView}
                        >
                            No challenges. No waiting. Start trading from Day 1 with a funded account powered by AI risk management.
                        </motion.p>
                        <motion.div
                            className="flex md:flex-row flex-col justify-center gap-3 w-full md:w-auto px-4 md:px-0"
                            {...landingMotionInView}
                        >
                            <a href="/pricing" className="btn-gradient-left text-center w-full md:w-auto text-lg font-bold py-2 px-3 md:px-6 rounded-[10px]">
                                Get Funded Now
                            </a>
                            <a href="/pricing" className="btn-register w-full md:w-auto backdrop-blur-sm bg-white/10 text-lg font-bold py-2 px-3 md:px-6 rounded-[10px]">
                                View Pricing
                            </a>
                        </motion.div>

                        <div className="mt-10">
                            <Hero3dCrousel />

                        </div>


                    </div>

                    {/* /mobile reponsive/   */}
                    <motion.div
                        className=" bg-no-repeat bg-cover bg-center"
                        {...landingMotionInView}
                    >
                        <div className="block md:!hidden  px-4">

                            {/* subtitle The lading prop firm */}

                            <motion.div
                                className="w-full h-auto p-[1.5px] rounded-[20px] bg-gradient-to-l from-[#1CCDE6] to-[#DBD633] flex justify-center items-center"
                                {...landingMotionInView}
                            >
                                <div className="w-full px-3 bg-black/80 backdrop-blur-sm text-dark rounded-[20px] py-1 flex items-center justify-center">
                                    <span
                                        className="bg-clip-text text-[12px] text-transparent font-nexa font-bold"
                                        style={{
                                            backgroundImage:
                                                "linear-gradient(to left, #D7D536, #20CDE2)",
                                            display: "inline-block",
                                        }}
                                    >
                                        {("Trusted by Thousands")}
                                    </span>
                                </div>
                            </motion.div>
                            <ReviewSlider />
                        </div>
                    </motion.div>
                </div>
            </div>


        </div>
    );
}

